const path = require('path')

const resolve = dir => {
  return path.join(__dirname, dir)
}

// 项目部署基础
// 默认情况下，我们假设你的应用将被部署在域的根目录下,
// 例如：https://www.my-app.com/
// 默认：'/'
// 如果您的应用程序部署在子路径中，则需要在这指定子路径
// 例如：https://www.foobar.com/my-app/
// 需要将它改为'/my-app/'
const BASE_URL = process.env.NODE_ENV === 'production' ? '/' : '/'

module.exports = {
  // 禁用文件名 hash（解决打包后请求参数带乱码后缀的问题）
  filenameHashing: false,
  
  // Project deployment base
  // By default we assume your app will be deployed at the root of a domain,
  // e.g. https://www.my-app.com/
  // If your app is deployed at a sub-path, you will need to specify that
  // sub-path here. For example, if your app is deployed at
  // https://www.foobar.com/my-app/
  // then change this to '/my-app/'
  publicPath: BASE_URL,
  // tweak internal webpack configuration.
  // see https://github.com/vuejs/vue-cli/blob/dev/docs/webpack.md
  // 如果你不需要使用eslint，把lintOnSave设为false即可
  lintOnSave: true,
  chainWebpack: config => {

    // 查找图片文件的处理规则
    const imagesRule = config.module.rule('images')

    // 覆盖原有的 url-loader 配置，将其关闭
    imagesRule
      .use('url-loader')
      .loader('url-loader')
      .tap(options => {
        // 修改选项，将 limit 设置为 0，强制所有图片都走 file-loader，不转为 Data URL
        return {
          ...options,
          limit: 0
        }
      })
    config.resolve.alias
      .set('@', resolve('src')) // key,value自行定义，比如.set('@@', resolve('src/components'))
      .set('_c', resolve('src/components'))
  },
  // 打包时不生成.map文件
  productionSourceMap: true,
  // 这里写你调用接口的基础路径，来解决跨域，如果设置了代理，那你本地开发环境的axios的publicPath要写为 '' ，即空字符串
  devServer: {
    disableHostCheck: true,
    // disableHostCheck: true
     proxy: 'http://127.0.0.1:9000/'
    // proxy: 'http://10.10.111.111:58000/'
    // proxy: 'http://ops-demo.shinezone.net.cn/api/'
    // proxy: 'https://demo.opendevops.cn/api/'
  }
}
